import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ColheitasService } from '../../../shared/services/api/ColheitasService';
import RConheitas from './RelatorioColheitas';

export const RelatorioColheita: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs());
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {      
      return;         
    }
    setOpenmsg(false);       
  };       
                 
  const handleImprimir = () => {
    ColheitasService
    .RColheitas(dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {                
          setTms('error');
          setMsg(result.message);   
          setOpenmsg(true);               
        }else {  
          if(result.length > 0){  
            RConheitas(result, `Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`);  
          }else{
            setTms('warning');
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);  
          }
        }                   
      });           
  };
      
  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}       
          variant="filled"
          sx={{ width: '100%' }}
        >      
          {msg}
        </Alert>   
      </Snackbar>
      <Box gap={1} display="flex" alignItems="center" alignSelf='center' margin={1} alignContent='center'></Box>
      <Box width='auto' alignItems="center" component={Paper} height="auto" margin={1}
        alignContent='center'>
        <DialogTitle>Relatório de Colheitas</DialogTitle>
        <DialogContent dividers>
          {isLoading && (                      
            <Grid item>        
              <LinearProgress variant='indeterminate' />
            </Grid>       
          )}    
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                   sx={{ width:150 }}  
                  format='DD/MM/YYYY'
                  value={dataInicial}
                  onChange={(newValue) => setDataInicial(newValue)}
                  label='Data Inicial'
                  slotProps={{
                    textField: {    
                      size: 'small',      
                    }     
                  }}  
                />
              </LocalizationProvider>         

              <LocalizationProvider 
                dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{marginLeft:2, width:150 }}  
                  format='DD/MM/YYYY'
                  value={dataFinal}
                  onChange={(newValue) => setDataFinal(newValue)}
                  label='Data Final'
                  slotProps={{
                    textField: {
                      size: 'small',
                    }
                  }}
                />
              </LocalizationProvider>

        </DialogContent>
        <DialogActions>
          <Button variant='contained' autoFocus onClick={handleImprimir}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );  
};   